const empty = (v) => v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length);

// Chart values only fill boxes that are still empty
export const fillEmpty = (prev, add) => ({ ...prev, ...Object.fromEntries(Object.entries(add).filter(([k, v]) => !empty(v) && empty(prev[k]))) });

// Saved form values (incl. upload drafts) win over defaults; nested groups (e.g. checkbox sets) merge key by key
export const mergeSaved = (prev, saved = {}) => {
  const out = { ...prev };
  Object.entries(saved || {}).forEach(([k, v]) => {
    if (empty(v)) return;
    out[k] = v && typeof v === 'object' && !Array.isArray(v) && prev[k] && typeof prev[k] === 'object' ? { ...prev[k], ...v } : v;
  });
  return out;
};
